module.exports = __webpack_public_path__ + "img/intro1_ja.0e8e4e1e.jpg";